import styled from 'styled-components';

interface HeaderProps {
  headerColor: string;
  counterColor: string;
}

interface ButtonProps {
  hoverColor: string;
}

interface FooterProps {
  backgroundColor: string;
  isDark: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0.1rem 0.1rem 0.4rem -0.25rem;
  min-width: 30vw;
  flex: 1;

  @media (max-width: 996px) {
    box-shadow: none;
  }
`;

export const Header = styled.header<HeaderProps>`
  span {
    display: flex;
    background-color: ${(props) => props.counterColor};
    justify-content: space-around;
    font-size: 1rem;
    height: 2.5rem;

    p {
      color: #fff;
      display: flex;
      align-items: center;
      margin: 0;

      svg {
        margin-right: 8px;
      }
    }
  }

  @media (max-width: 996px) {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  > p {
    font-size: 2rem;
    margin: 1.5rem 0;
  }

  button:nth-child(4) {
    margin-top: 0px;
  }

  @media (max-width: 997px) {
    button:first-child {
      display: none;
    }

    button:nth-child(2) {
      display: none;
    }

    button:nth-child(4) {
      margin-top: 1rem;
    }

    > p {
      display: none;
    }
  }
`;

export const Button = styled.button<ButtonProps>`
  background: transparent;
  margin: 0.75rem 0 0;
  height: 2.75rem;
  width: 18rem;
  transition: transform 0.2s;
  background: #fafafa;
  box-shadow: 0.1rem 0.1rem 0.5rem -0.1rem;

  position: relative;

  &:hover {
    transform: scale(1.1);
    background: ${(props) => props.hoverColor};
    p {
      color: ${({ theme }) => theme.white};
    }
  }

  p {
    margin: 0;
    font-size: 1.25rem;
    color: ${({ theme }) => theme.black};
  }

  .alternative {
    position: absolute;
    left: 1rem;
  }

  @media (max-width: 996px) {
    width: calc(100% - 4rem);
  }
`;

export const Footer = styled.footer<FooterProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    margin-bottom: 6px;
  }

  p {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 36px;
    text-align: center;
    font-size: 1rem;
    color: #fff;
    background: ${(props) => props.backgroundColor};
    margin: 0;

    svg {
      margin-left: 8px;
      transform: rotate(180deg);
    }
  }

  &::before {
    content: '';
    width: 15rem;
    height: 1px;
    background: ${(props) => (props.isDark ? '#fff' : '#000')};
    opacity: 0.4;
    margin: 1.25rem auto;
  }

  /* @media (max-width: 997px) {
    width: calc(100% - 2rem);
    padding-left: 2rem;
    padding-top: 0.75rem;

    p {
      display: none;
    }

    div {
      display: none;
    }

    &::before {
      display: none;
    }
  } */

  @media (max-width: 997px) {
    display: none;
  }
`;
